<mat-card>
    <mat-card-header>
        <mat-card-title>
            Region {{regionCode}}: Resolved Match Tasks ( {{tableDataSource.data.length}} )
            <br>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-divider></mat-divider>
        <br>
        <div class="row">

            <mat-form-field appearance="fill" class="col-lg-3">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" [max]="toDate"
                    (dateChange)="onCheckedChange()">
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>


            <mat-form-field appearance="fill" class="col-lg-3">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" [min]="fromDate" [max]="maxDate"
                    (dateChange)="onCheckedChange()">
                <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>


            <section class="example-section" class="col-lg-3">
                <mat-checkbox class="example-margin" [(ngModel)]="checked" (change)="onCheckedChange()">
                    Show Resolved by CALPADS-API
                </mat-checkbox>
            </section>


        </div>
        <div *ngIf="isLoading">
            <mat-spinner></mat-spinner>
        </div>
        <app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

        <div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
            <div class="row" class="margin-top-md padding-top: 20px">
                <mat-form-field class="col-lg-12">
                    <mat-label>Filter</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Filter items below"
                        class="txtDistrictFilterMatCss" #input>
                </mat-form-field>
            </div>
            <div class="row table-responsive">
                <mat-table [dataSource]="tableDataSource" (matSortChange)="setupSorting($event)" matSort
                    class="mat-elevation-z8">

                    <ng-container matColumnDef="Action">
                        <mat-header-cell *matHeaderCellDef style="min-width:70px;">
                            Action
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                           <!-- <edit-child-modal-btn [studentId]="element.ID" [type]="'icon'" [icon]="'visibility'">
                                {{element}} -->
                            <button mat-icon-button color="primary" matTooltip="View" (click)="openDialog(element)"
                              > <!--   *ngIf="featurePermissions['View Service Administrations']"  -->
                                <mat-icon>visibility</mat-icon>
                            </button>
                           <!-- </edit-child-modal-btn>-->
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Name">>
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            Name
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.STUDENT.PERSON.LAST_NAME |
                            titlecase}}{{(element.STUDENT.PERSON.SECOND_LAST_NAME
                            ? ' ' + element.STUDENT.PERSON.SECOND_LAST_NAME + ',': ',') | titlecase}}
                            {{element.STUDENT.PERSON.FIRST_NAME |
                            titlecase}}
                            {{element.STUDENT.PERSON.MIDDLE_INITIAL | titlecase}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="MSDNumber">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <edit-child-modal-btn [studentId]="element.STUDENT.ID" [type]="'string'"
                                [displayText]="element.STUDENT.MSD_NUMBER">
                            </edit-child-modal-btn>

                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="InquiryDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Inquiry Date</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.CALPADS_STUDENTS_HISTORY.INQUIRY_DATE | simpleDateTime}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="MatchType">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Match Type</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            @if(!checked)
                            {
                            <ng-container [ngSwitch]="element.CALPADS_STUDENTS_HISTORY.STATUS">
                                <span *ngSwitchCase="'11'">Manual Match</span>
                                <span *ngSwitchCase="'12'">UnResolved</span>
                                <span *ngSwitchCase="'13'">No match </span>
                                <span *ngSwitchCase="'14'">Void</span>
                                <span *ngSwitchCase="'15'">Empty response</span>
                                <span *ngSwitchDefault></span>
                            </ng-container>

                            }
                            @else {
                            <ng-container [ngSwitch]="element.CALPADS_STUDENTS_HISTORY.WINNING_TYPE">
                                <span *ngSwitchCase="'1'">FN, LN , DOB, SSID</span>
                                <span *ngSwitchCase="'2'">FN, DOB, SSID</span>
                                <span *ngSwitchCase="'3'">FN, LN1, LN2 , DOB</span>
                                <span *ngSwitchCase="'4'">FN, MN, DOB, Birth City</span>
                                <span *ngSwitchCase="'5'">FN, MN, DOB, Birth City</span>
                                <span *ngSwitchCase="'11'">Resolved</span>
                                <span *ngSwitchCase="'12'">UnResolved</span>
                                <span *ngSwitchCase="'13'">No match </span>
                                <span *ngSwitchCase="'14'">Void</span>
                                <span *ngSwitchCase="'15'">Empty response</span>
                                <span *ngSwitchDefault></span>
                            </ng-container>
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ResolvedSSID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Resolved SSID</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.CALPADS_STUDENTS_HISTORY.IDENTIFIER_VALUE}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ResolvedBy">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Resolved By</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            @if(checked)
                            {
                                CALPADS-API
                            }
                            @else
                            {
                            {{element.CALPADS_STUDENTS_HISTORY.RESOLVED_USER}}
                            }
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ResolvedDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Resolved Date</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.CALPADS_STUDENTS_HISTORY.RESOLVED_DATE | simpleDateTime}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25,50, 100]" aria-label="Select page of users"></mat-paginator>

    </mat-card-content>
</mat-card>